// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.payment-link-main-div {
  border-radius: 16px;
  border: 1.2px solid var(--border-tertiary, rgba(1, 1, 2, 0.12));
  width: 100% !important;
  flex-shrink: 0;
  height: 100% !important;
  padding: 24px !important;
}

.titleCreate {
  display: inline-flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 8px;
}
.error {
  display: flex;
  align-items: flex-start;
  margin-top: 2px;
}
.firstTitle {
  display: flex;
}

.form-div {
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 28px;
  margin-top: 40px;
}
.payment-link-g0 {
  width: 100%;
  display: flex;
  gap: 80px;
}
.payment-link-g1 {
  width: 100%;
  display: flex;
  gap: 80px;
}
.payment-link-g2 {
  width: 100%;
  display: flex;
  gap: 80px;
}
.payment-link-g3 {
  width: 100%;
  display: flex;
  gap: 80px;
}
.payment-link-g3-1 {
  width: 50%;
}
.payment-link-g3-2 {
  display: flex;
  flex-direction: column;
  gap: 28px;
  width: 50%;
}
.fieldContainer {
  height: 76px;
  width: 50%;
}
.fieldContainer2 {
  height: 76px;
  width: 100%;
}
.fieldContainer3 {
  width: 100%;
}

.autocomplete.MuiSvgIcon-root {
  height: 24px !important;
  width: 24px !important;
}

.btn-container {
  display: flex;
  margin: 36px 0px;
  justify-content: flex-end;
  align-items: flex-end;
  width: 100%;
}

@media only screen and (max-width: 520px) {
  .payment-link-main-div {
    margin: 0px 8px 0px 8px !important;
    padding: 24px 20px 24px 20px !important;
    border: none;
  }
  .heightDescriptionCreate.MuiInputBase-root.MuiOutlinedInput-root {
    height: 140 !important;
  }
}

@media only screen and (max-width: 1045px) {
  .form-div {
    justify-content: center;
    align-items: center;
    padding-left: 0% !important;
    padding-right: 0% !important;
    gap: 32px;
  }
  .payment-link-g0 {
    flex-direction: column;
    gap: 32px;
  }
  .payment-link-g1 {
    flex-direction: column;
    gap: 32px;
  }
  .payment-link-g2 {
    flex-direction: column;
    gap: 32px;
  }
  .payment-link-g3 {
    flex-direction: column;
    gap: 32px;
  }

  .payment-link-g3-1 {
    width: 100%;
  }
  .payment-link-g3-2 {
    width: 100%;
    gap: 32px;
  }
  .fieldContainer {
    width: 100%;
  }
  .fieldContainer2 {
    width: 100%;
  }
  .fieldContainer3 {
    width: 100%;
  }
  .btn-container {
    justify-content: flex-start;
  }
}

.fontCreate.MuiFormLabel-root.MuiInputLabel-root {
  font-weight: 400;
  height: 18px;
  font-size: 14px;
  color: var(--character-title-85, rgba(0, 0, 0, 0.85));
}

.textFieldCreate.MuiInputBase-root.MuiOutlinedInput-root {
  width: 100%;
}
.textFieldCreate2.MuiInputBase-root.MuiOutlinedInput-root {
  width: 100%;
}

.heightDescriptionCreate.MuiInputBase-root.MuiOutlinedInput-root {
  height: 271px !important;
  display: block;
}

.iconStyleCreate {
  width: 24px;
  height: 24px;
}

.buttonCreate.MuiButtonBase-root.MuiButton-root {
  color: white;
  font-family: Poppins;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  text-transform: none;
  display: flex;
  height: 45px;
  /* min-width: 60px; */
  padding: 0px 24px;
  align-items: center;
  border-radius: 8px;
  background: #403e9f !important;
  margin-left: 10px;
  margin-top: 28px;
}

.MuiButtonBase-root.MuiButton-root.buttonStyleCreate {
  color: var(--text-inverse-highest, rgba(254, 254, 254, 0.92));

  /* Body/B2 Semi bold */
  font-family: Poppins;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 18px; /* 128.571% */
}

.buttonDetails .MuiButtonBase-root.MuiButton-root {
  color: white;
  font-family: Poppins;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  text-transform: none;
  display: flex;
  height: 45px;
  /* min-width: 60px; */
  padding: 0px 24px;
  align-items: center;
  border-radius: 8px;
  background: #403e9f;
}

.disableTextField.MuiInputBase-input.MuiOutlinedInput-input {
  width: 317px !important;
  padding: 11px 8px !important;
  background: white !important;
}

.PhoneInputInput {
  height: 40px;
  border-radius: 2px !important;
  padding-left: 10px;
}
.PhoneInputCountry {
  margin-right: 0px;
}

.PhoneInputCountrySelect {
  position: unset !important;
  width: 65px !important;
}
.PhoneInputCountryIconImg {
  margin-left: -55px;
}

.PhoneInputCountryIcon--border {
  background-color: unset !important;
  box-shadow: unset !important;
}

.PhoneInputCountrySelectArrow {
  margin-left: -40px !important;
  margin-right: 13px;
}

.hideborder .css-1d3z3hw-MuiOutlinedInput-notchedOutline {
  border-left: none;
}

.buttonNotify.MuiButtonBase-root.MuiButton-root {
  display: inline-flex;
  height: 36px;
  width: 85px;
  padding: 0px 24px;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
  border-radius: 8px;
  background: var(--generic-primary, #24b7aa);
  align-self: end;
  color: var(--text-inverse-highest, rgba(254, 254, 254, 0.92));
  font-family: Poppins;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  text-transform: none;
}

.notifyText.MuiTypography-root {
  color: var(--text-medium, rgba(1, 1, 2, 0.6));

  font-family: Poppins;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 14px; /* 116.667% */
  display: flex;
  align-items: center;
}
.notifySmsText.MuiTypography-root {
  color: var(--text-medium, rgba(1, 1, 2, 0.6));

  font-family: Poppins;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 14px; /* 116.667% */
  display: flex;
  align-items: center;
}

.notifySize .MuiSvgIcon-root {
  height: 16px !important;
  width: 16px !important;
  /* margin-top: -14px; */
}

.react-tel-input .flag-dropdown {
  background: #a6eee8 !important;
}
`, "",{"version":3,"sources":["webpack://./src/components/pages/paymentLink/createPaymentLinks.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,+DAA+D;EAC/D,sBAAsB;EACtB,cAAc;EACd,uBAAuB;EACvB,wBAAwB;AAC1B;;AAEA;EACE,oBAAoB;EACpB,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;EACvB,QAAQ;AACV;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,eAAe;AACjB;AACA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,aAAa;EACb,SAAS;AACX;AACA;EACE,WAAW;EACX,aAAa;EACb,SAAS;AACX;AACA;EACE,WAAW;EACX,aAAa;EACb,SAAS;AACX;AACA;EACE,WAAW;EACX,aAAa;EACb,SAAS;AACX;AACA;EACE,UAAU;AACZ;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,UAAU;AACZ;AACA;EACE,YAAY;EACZ,UAAU;AACZ;AACA;EACE,YAAY;EACZ,WAAW;AACb;AACA;EACE,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE;IACE,kCAAkC;IAClC,uCAAuC;IACvC,YAAY;EACd;EACA;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,uBAAuB;IACvB,mBAAmB;IACnB,2BAA2B;IAC3B,4BAA4B;IAC5B,SAAS;EACX;EACA;IACE,sBAAsB;IACtB,SAAS;EACX;EACA;IACE,sBAAsB;IACtB,SAAS;EACX;EACA;IACE,sBAAsB;IACtB,SAAS;EACX;EACA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,WAAW;EACb;EACA;IACE,WAAW;IACX,SAAS;EACX;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,qDAAqD;AACvD;;AAEA;EACE,WAAW;AACb;AACA;EACE,WAAW;AACb;;AAEA;EACE,wBAAwB;EACxB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,aAAa;EACb,YAAY;EACZ,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,8BAA8B;EAC9B,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,6DAA6D;;EAE7D,sBAAsB;EACtB,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,aAAa;AAClC;;AAEA;EACE,YAAY;EACZ,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,aAAa;EACb,YAAY;EACZ,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,4BAA4B;EAC5B,4BAA4B;AAC9B;;AAEA;EACE,YAAY;EACZ,6BAA6B;EAC7B,kBAAkB;AACpB;AACA;EACE,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;EAC1B,sBAAsB;AACxB;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;EAClC,4BAA4B;AAC9B;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,kBAAkB;EAClB,2CAA2C;EAC3C,eAAe;EACf,6DAA6D;EAC7D,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,6CAA6C;;EAE7C,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,aAAa;EAChC,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,6CAA6C;;EAE7C,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,aAAa;EAChC,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,8BAA8B;AAChC","sourcesContent":[".payment-link-main-div {\n  border-radius: 16px;\n  border: 1.2px solid var(--border-tertiary, rgba(1, 1, 2, 0.12));\n  width: 100% !important;\n  flex-shrink: 0;\n  height: 100% !important;\n  padding: 24px !important;\n}\n\n.titleCreate {\n  display: inline-flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: flex-start;\n  gap: 8px;\n}\n.error {\n  display: flex;\n  align-items: flex-start;\n  margin-top: 2px;\n}\n.firstTitle {\n  display: flex;\n}\n\n.form-div {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  gap: 28px;\n  margin-top: 40px;\n}\n.payment-link-g0 {\n  width: 100%;\n  display: flex;\n  gap: 80px;\n}\n.payment-link-g1 {\n  width: 100%;\n  display: flex;\n  gap: 80px;\n}\n.payment-link-g2 {\n  width: 100%;\n  display: flex;\n  gap: 80px;\n}\n.payment-link-g3 {\n  width: 100%;\n  display: flex;\n  gap: 80px;\n}\n.payment-link-g3-1 {\n  width: 50%;\n}\n.payment-link-g3-2 {\n  display: flex;\n  flex-direction: column;\n  gap: 28px;\n  width: 50%;\n}\n.fieldContainer {\n  height: 76px;\n  width: 50%;\n}\n.fieldContainer2 {\n  height: 76px;\n  width: 100%;\n}\n.fieldContainer3 {\n  width: 100%;\n}\n\n.autocomplete.MuiSvgIcon-root {\n  height: 24px !important;\n  width: 24px !important;\n}\n\n.btn-container {\n  display: flex;\n  margin: 36px 0px;\n  justify-content: flex-end;\n  align-items: flex-end;\n  width: 100%;\n}\n\n@media only screen and (max-width: 520px) {\n  .payment-link-main-div {\n    margin: 0px 8px 0px 8px !important;\n    padding: 24px 20px 24px 20px !important;\n    border: none;\n  }\n  .heightDescriptionCreate.MuiInputBase-root.MuiOutlinedInput-root {\n    height: 140 !important;\n  }\n}\n\n@media only screen and (max-width: 1045px) {\n  .form-div {\n    justify-content: center;\n    align-items: center;\n    padding-left: 0% !important;\n    padding-right: 0% !important;\n    gap: 32px;\n  }\n  .payment-link-g0 {\n    flex-direction: column;\n    gap: 32px;\n  }\n  .payment-link-g1 {\n    flex-direction: column;\n    gap: 32px;\n  }\n  .payment-link-g2 {\n    flex-direction: column;\n    gap: 32px;\n  }\n  .payment-link-g3 {\n    flex-direction: column;\n    gap: 32px;\n  }\n\n  .payment-link-g3-1 {\n    width: 100%;\n  }\n  .payment-link-g3-2 {\n    width: 100%;\n    gap: 32px;\n  }\n  .fieldContainer {\n    width: 100%;\n  }\n  .fieldContainer2 {\n    width: 100%;\n  }\n  .fieldContainer3 {\n    width: 100%;\n  }\n  .btn-container {\n    justify-content: flex-start;\n  }\n}\n\n.fontCreate.MuiFormLabel-root.MuiInputLabel-root {\n  font-weight: 400;\n  height: 18px;\n  font-size: 14px;\n  color: var(--character-title-85, rgba(0, 0, 0, 0.85));\n}\n\n.textFieldCreate.MuiInputBase-root.MuiOutlinedInput-root {\n  width: 100%;\n}\n.textFieldCreate2.MuiInputBase-root.MuiOutlinedInput-root {\n  width: 100%;\n}\n\n.heightDescriptionCreate.MuiInputBase-root.MuiOutlinedInput-root {\n  height: 271px !important;\n  display: block;\n}\n\n.iconStyleCreate {\n  width: 24px;\n  height: 24px;\n}\n\n.buttonCreate.MuiButtonBase-root.MuiButton-root {\n  color: white;\n  font-family: Poppins;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 600;\n  text-transform: none;\n  display: flex;\n  height: 45px;\n  /* min-width: 60px; */\n  padding: 0px 24px;\n  align-items: center;\n  border-radius: 8px;\n  background: #403e9f !important;\n  margin-left: 10px;\n  margin-top: 28px;\n}\n\n.MuiButtonBase-root.MuiButton-root.buttonStyleCreate {\n  color: var(--text-inverse-highest, rgba(254, 254, 254, 0.92));\n\n  /* Body/B2 Semi bold */\n  font-family: Poppins;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 18px; /* 128.571% */\n}\n\n.buttonDetails .MuiButtonBase-root.MuiButton-root {\n  color: white;\n  font-family: Poppins;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 600;\n  text-transform: none;\n  display: flex;\n  height: 45px;\n  /* min-width: 60px; */\n  padding: 0px 24px;\n  align-items: center;\n  border-radius: 8px;\n  background: #403e9f;\n}\n\n.disableTextField.MuiInputBase-input.MuiOutlinedInput-input {\n  width: 317px !important;\n  padding: 11px 8px !important;\n  background: white !important;\n}\n\n.PhoneInputInput {\n  height: 40px;\n  border-radius: 2px !important;\n  padding-left: 10px;\n}\n.PhoneInputCountry {\n  margin-right: 0px;\n}\n\n.PhoneInputCountrySelect {\n  position: unset !important;\n  width: 65px !important;\n}\n.PhoneInputCountryIconImg {\n  margin-left: -55px;\n}\n\n.PhoneInputCountryIcon--border {\n  background-color: unset !important;\n  box-shadow: unset !important;\n}\n\n.PhoneInputCountrySelectArrow {\n  margin-left: -40px !important;\n  margin-right: 13px;\n}\n\n.hideborder .css-1d3z3hw-MuiOutlinedInput-notchedOutline {\n  border-left: none;\n}\n\n.buttonNotify.MuiButtonBase-root.MuiButton-root {\n  display: inline-flex;\n  height: 36px;\n  width: 85px;\n  padding: 0px 24px;\n  align-items: center;\n  gap: 10px;\n  flex-shrink: 0;\n  border-radius: 8px;\n  background: var(--generic-primary, #24b7aa);\n  align-self: end;\n  color: var(--text-inverse-highest, rgba(254, 254, 254, 0.92));\n  font-family: Poppins;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 600;\n  text-transform: none;\n}\n\n.notifyText.MuiTypography-root {\n  color: var(--text-medium, rgba(1, 1, 2, 0.6));\n\n  font-family: Poppins;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 14px; /* 116.667% */\n  display: flex;\n  align-items: center;\n}\n.notifySmsText.MuiTypography-root {\n  color: var(--text-medium, rgba(1, 1, 2, 0.6));\n\n  font-family: Poppins;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 14px; /* 116.667% */\n  display: flex;\n  align-items: center;\n}\n\n.notifySize .MuiSvgIcon-root {\n  height: 16px !important;\n  width: 16px !important;\n  /* margin-top: -14px; */\n}\n\n.react-tel-input .flag-dropdown {\n  background: #a6eee8 !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
